import React, { useRef, useState, useEffect } from 'react'
import { IonButton, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonPage, IonRow, IonSlide, IonSlides, IonText, IonToolbar } from '@ionic/react';
import { Redirect, RouteComponentProps } from 'react-router';
import { arrowBack, arrowForward } from 'ionicons/icons';
import { goToPage, goToPageWithState } from '../../helpers/app_actions';
import { useSelector } from 'react-redux';
import Login from '../../components/Login';
import Walk from '../Walk';
import { RootState } from '../../redux/reducers';

interface MyComponentProps extends RouteComponentProps<{ 
  walkId: string; 
}> {
  walkId: string
}

const SharePrivateWalk = (props: MyComponentProps) => {
  const walkId = props.match.params.walkId
  const [currentSlide, setCurrentSlide] = useState<number>()
  const [lastSlide, setLastSlide] = useState<boolean>(false)
  const [firstSlide, setFirstSlide] = useState<boolean>(true)
  const [slideLength, setSlideLength] = useState<number>()
  const [guest, setGuest] = useState({
    name: '',
    isSet: false
  })
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [view, setView] = useState('guest')
  // const [loaded, setLoaded] = useState(false)
  const isAuthenticated = useSelector((state: RootState) => state.logIn.loggedIn)
  const tabBar = document.getElementById('myTabBar')

  useEffect(() => {
    if(walkId) {
      // setLoaded(true)
    }
  }, [walkId])

  useEffect(() => {
    if(view === 'guest') {
      if(tabBar) {
        tabBar.className += " tabBar--hidden"
      }
    } else {
      setModalIsOpen(true)
    }
  }, [view, tabBar, isAuthenticated])

  const slideRef = useRef<HTMLIonSlidesElement>(null);
  const slideOpts = {
    initialSlide: 0,
    speed: 400
  };

  const sliderInit = () => {
    slideRef.current?.getActiveIndex()
      .then(res => setCurrentSlide(res))
    slideRef.current?.length().then(res => setSlideLength(res))
    // console.log(slideLength)
  }

  const didChange = () => {
    slideRef.current?.getActiveIndex().then(res => setCurrentSlide(res))
    slideRef.current?.isEnd().then(res => {
      setLastSlide(res)
    })
    slideRef.current?.isBeginning().then(res => setFirstSlide(res))
  }

  const handlePrevious = () => {
    slideRef.current?.slidePrev()
  };

  const handleNext = () => {
    slideRef.current?.slideNext()
  };

  const handleGuest = (e: any) => {
    setGuest({
      ...guest,
      name: e.target.value
    })
  }

  const backToStart = () => {
    setView('guest')
  }

  const afterLogInPage = () => {
    setModalIsOpen(false)
    goToPage(`/walk/walk/${walkId}`)
  }

  if(isAuthenticated) {
    return <Redirect to={'/walk/walk/' + walkId}/>
  } else {
    return <IonPage className="cheap_desktop">
      { view === 'guest' ?
      <>
        <IonContent class="fullWidth fullHeight">
          { !guest.isSet ? 
          <IonSlides
            onIonSlidesDidLoad={sliderInit}
            onIonSlideDidChange={didChange}
            pager={true} 
            options={slideOpts}
            ref={slideRef}>
            <IonSlide>
              <IonRow class="fullWidth px-8 mt-24">
                <img src="assets/images/Blue_Logo_TM.svg" alt="" className="px-8 my-4" width="150px"/>
              </IonRow>
              <IonRow class="infoArea">
                <IonText color="darkblue"><h1>Du har fått en inbjudan till ett promenadmöte</h1></IonText>
              </IonRow>
              <IonGrid class="fullWidth fullHeight flex flex-col items-center mt-12">
                <IonRow class="p-2 fullWidth">
                  <IonButton 
                    // onClick={() => setView('login')}
                    onClick={() => goToPageWithState('/walk/enter/login', '/walk/walk/' + walkId)}
                    class="fullWidth"
                    expand="block">Logga in</IonButton>
                </IonRow>
                <IonRow class="p-2 fullWidth">
                  <IonButton 
                    onClick={() => goToPageWithState('/walk/enter/create', '/walk/walk/' + walkId)}
                    class="fullWidth"
                    fill="outline" 
                    expand="block">Skapa konto</IonButton>
                </IonRow>
                <IonRow class="p-4">
                  <IonButton 
                    onClick={() => handleNext()}
                    fill="clear" 
                    color="darkblue">
                    Gå vidare som gäst
                    <IonIcon icon={arrowForward} />
                  </IonButton>
                </IonRow>
              </IonGrid>
            </IonSlide>
            <IonSlide>
              <IonHeader class="fullWidth">
                <IonToolbar>
                  <IonButton 
                    onClick={() => handlePrevious()}
                    fill="clear"
                    slot="start">
                    <IonIcon icon={arrowBack}/>
                  </IonButton>
                </IonToolbar>
              </IonHeader>
              <IonGrid class="fullWidth fullHeight flex flex-col justify-center items-center">
                <IonRow class="fullWidth p-2">
                  <article className="modalInput fullWidth">
                    <input
                      type="text"
                      id="guest"
                      className="text_center"
                      value={guest.name}
                      onChange={handleGuest}
                      maxLength={40}
                      required/>
                    <label htmlFor="title">Namn</label>
                  </article>
                </IonRow>
                <IonRow class="fullWidth p-2">
                  <IonButton 
                    expand="block" 
                    class="fullWidth"
                    onClick={() => {
                      setGuest({...guest, isSet: true})
                      setView('guest')
                    }}>
                    Gå till promenaden 
                  </IonButton>
                </IonRow>
              </IonGrid>
            </IonSlide>
          </IonSlides>
          : 
          <>
            <Walk walkId={walkId} external={true} guest={guest}/>
          </>
          }
        </IonContent>
        { guest.isSet ? 
          <IonFooter>
            <IonToolbar>
              <IonRow>
                <IonCol size="6" class="p-2">
                  <IonButton 
                    onClick={() => goToPageWithState('/walk/enter/login', '/walk/walk/' + walkId)}
                    expand="block" 
                    color="darkblue" 
                    fill="outline">Logga in</IonButton>
                </IonCol>
                <IonCol size="6" class="p-2">
                  <IonButton 
                    onClick={() => goToPageWithState('/walk/enter/create', '/walk/walk/' + walkId)}
                    expand="block" 
                    color="darkblue">Skapa konto</IonButton>
                </IonCol>
              </IonRow>
            </IonToolbar>
          </IonFooter> 
          : null }
        </>
        : 
        <Login page={view} closeModal={backToStart} afterLoginPage={afterLogInPage}/>
      }
    </IonPage>
  }
}

export default SharePrivateWalk
